/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../components/Menu'

import { useForm } from "react-hook-form"

import { get, deleteItem, put } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router'

import { baseUrl } from '../../../Data'

export default function index() {
  const navigate = useNavigate()
  const { id } = useParams()

  const [resturants, setResturants] = useState([])
  const [category, setCategory] = useState([])
  const [categoryName, setCategoryName] = useState('')
  const [icon, setIcon] = useState()
  const [clickButton, setClickButton] = useState(false)

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const [withPic, setWithPic] = useState(false)

  document.title = 'ایجاد دسته بندی'

  const { register, handleSubmit, reset } = useForm()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/shops?token=${token}`)
      .then(respose => {
        setResturants(respose.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get(`/api/admin/categories/${id}?token=${token}`)
      .then(response => {
        setCategory(response.data.data[0])
        setCategoryName(response.data.data[0].shop[0].name)
        let defaultValues = {}
        defaultValues.title = response.data.data[0].title
        defaultValues.eTitle = response.data.data[0].eTitle
        defaultValues.level = response.data.data[0].level
        reset({ ...defaultValues })
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let formData = new FormData()

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    } 

    if (withPic) {
      formData.append('icon', icon)
      formData.append('shop', data.shop)
      formData.append('title', data.title)
      formData.append('eTitle', data.eTitle)
      formData.append('level', data.level)

      put(`/api/admin/categories/${id}?token=${token}`, formData, config)
        .then(response => {
          notify('success', response.data.messageFa)
          setTimeout(() => {
            navigate('/categories')
          }, 2000)
        }).catch(error => {
          setClickButton(false)
          if (error) {
            notify('error', error)
          }
          notify('error', 'خطا در ارسال اطلاعات')
        })
    } else {
      const dataForm = {
        shop: data.shop,
        title: data.title,
        eTitle: data.eTitle,
        level: data.level,
      }

      put(`/api/admin/categories/withoutpic/${id}?token=${token}`, dataForm)
        .then(response => {
          notify('success', response.data.messageFa)
          setTimeout(() => {
            navigate('/categories')
          }, 2000)
        })
        .catch(error => {
          if (error) {
            notify('error', error)
          }
          notify('error', 'خطا در ارسال اطلاعات')
        })
    }
  }

  const deleteHandler = (e) => {
    deleteItem(`/api/admin/categories/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/categories')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  const picHandler = () => {
    setWithPic(true)
  }

  return (
    <main id='panel'>
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید دسته بندی مورد نظر حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <ToastContainer rtl />
      <Menu page={'category'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text'>
                ویرایش دسته بندی
              </div>
              <div>
                <button onClick={e => { 
                  setCover(true)
                  setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'>حذف دسته بندی</button>
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد دسته بندی لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات دسته بندی
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantName'>انتخاب رستوران * : {categoryName}</label>
                <select id='resturantName' {...register("shop", { required: true })}>
                  {resturants ? resturants.map((item, index) => {
                    return <option key={index} value={item._id}>{item.name}</option>
                  }) : ''}
                </select>
                <small id='resturantNameAlert'>رستوران باید انتخاب شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantDetails'>نام دسته بندی * :</label>
                <input id='resturantDetails' {...register("title", { required: true, minLength: 3 })} type='text' placeholder='مثلا پیتزا' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantDetails'>نام دسته بندی انگلیسی * :</label>
                <input className='ltr' id='resturantDetails' {...register("eTitle", { required: true, minLength: 3 })} type='text' placeholder='pizza' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantAddress'>اولویت * :</label>
                <input id='resturantAddress' {...register("level", { required: true })} type='number' />
                <small id='resturantAddressAlert'>اولویت باید انتخاب شود</small>
              </div>
            </div>
            <div className="row" style={{ position: 'relative' }}>
              <div className='column' style={withPic ? {} : { display: 'none' }}>
                <label htmlFor='resturantTell'>تصویر دسته بندی * :</label>
                <input id='resturantTell' onChange={e => {
                  const fileSelect = e.target.files[0]
                  setIcon(fileSelect)
                }} type='file' />
                <small id='resturantTellAlert'>تصویر باید انتخاب شود</small>
              </div>
              <div className='column' style={withPic ? { display: 'none' } : {}}>
                <img width={'100px'} src={category ? `${baseUrl.address}${category.icon}` : ''} alt='logo' />
                <div className='positiveIcon' onClick={picHandler}>+</div>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'آپدیت دسته بندی'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
